import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { Box } from 'seagull';
import { Gift } from 'seagull/icons';
import styles from './VideoPlayer.module.scss';
const VIDEO_ID = 'zbXQwOdZYyk';
export const VideoPlayer = (param)=>{
    let { progress, onPlay, onPause, videoAlt, isMobile } = param;
    const iframeRef = useRef(null);
    const handleIframeLoad = useCallback(()=>{
        const iframe = iframeRef.current;
        if (!(iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow)) return;
        iframe.contentWindow.postMessage(JSON.stringify({
            event: 'listening'
        }), 'https://www.youtube.com');
    }, []);
    useEffect(()=>{
        const onMessage = (event)=>{
            if (event.origin !== 'https://www.youtube.com') return;
            try {
                var _data_info;
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                const playerState = data === null || data === void 0 ? void 0 : (_data_info = data.info) === null || _data_info === void 0 ? void 0 : _data_info.playerState;
                if (playerState === undefined) return;
                if (playerState === 1) {
                    onPlay();
                } else if (playerState === 2) {
                    onPause();
                }
            } catch (unused) {
            // ignore non-JSON messages
            }
        };
        window.addEventListener('message', onMessage);
        return ()=>window.removeEventListener('message', onMessage);
    }, [
        onPlay,
        onPause
    ]);
    return /*#__PURE__*/ _jsxs(motion.div, {
        className: clsx(styles.root, isMobile && styles.mobile),
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.4
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.videoWrapper,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.videoContainer,
                    children: /*#__PURE__*/ _jsx("iframe", {
                        ref: iframeRef,
                        className: styles.iframe,
                        src: "https://www.youtube.com/embed/".concat(VIDEO_ID, "?autoplay=1&controls=1&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&origin=").concat(window.location.origin),
                        title: videoAlt,
                        allow: "autoplay; encrypted-media",
                        allowFullScreen: true,
                        onLoad: handleIframeLoad
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(motion.div, {
                className: styles.controls,
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                transition: {
                    delay: 0.3,
                    duration: 0.4
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.progressTrack,
                        children: /*#__PURE__*/ _jsx(Box, {
                            className: styles.progressFill,
                            style: {
                                width: "".concat(progress, "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.giftIcon,
                        children: /*#__PURE__*/ _jsx(Gift, {
                            size: 32
                        })
                    })
                ]
            })
        ]
    }, "playing");
};
